import {
  Button,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  /** Согласие на повторный запрос записи; окно закрывается само */
  onConfirm: () => void;
};

/**
 * Окно подтверждения повторного запроса записи диалога у интеграции-источника.
 */
export const RecordingFetchRetryDialog: FC<Props> = ({ onConfirm }) => {
  const { t } = useTranslation(['dialogs', 'common']);

  return (
    <DialogContent className="max-w-md">
      <DialogHeader>
        <DialogTitle>{t('dialogs:audioFetchRetry.title')}</DialogTitle>
      </DialogHeader>
      <DialogDescription>{t('dialogs:audioFetchRetry.description')}</DialogDescription>
      <DialogFooter>
        <DialogClose asChild>
          <Button variant="ghost">{t('common:cancel')}</Button>
        </DialogClose>
        <DialogClose asChild>
          <Button onClick={onConfirm}>{t('dialogs:audioFetchRetry.confirm')}</Button>
        </DialogClose>
      </DialogFooter>
    </DialogContent>
  );
};
